const initialState = { purchasesActivity: null };

const purchasesActivityReducer = (state = initialState, action) => {
  switch (action.type) {
    case "FETCH_PURCHASES_ACTIVITY":
      return {
        ...state,
        purchasesActivity: action.data,
      };

    case "CREATE_PURCHASE_ACTIVITY": {
      let dt = state.purchasesActivity.concat(action.data);
      return {
        ...state,
        purchasesActivity: dt,
      };
    }
    case "UPDATE_PURCHASE_ACTIVITY": {
      let dt = state.purchasesActivity.map((order) => {
        if (order._id === action.data._id) {
          return action.data;
        }
        return order;
      });
      return {
        ...state,
        purchasesActivity: dt,
      };
    }
    default:
      return state;
  }
};

export default purchasesActivityReducer;
